export function getSelectedFixtureId({ getMethodsOf }) {
    return getMethodsOf('router').getSelectedFixtureId();
}
